/** Same-origin path nginx / CRA dev proxy forwards to Nominatim. */
export const DEFAULT_GEOCODE_PROXY_PATH = '/geocode-proxy';

/** Legacy dev-only mount kept for older local setups. */
export const LEGACY_DEV_GEOCODE_PROXY_PATH = '/dev-geocode-proxy';

/**
 * Base URL for Nominatim geocode requests from the browser.
 * Always same-origin — never call nominatim.openstreetmap.org directly (CORS + usage policy).
 */
export function resolveGeocodeProxyBaseUrl(): string {
  const override = process.env.REACT_APP_GEOCODE_PROXY_PATH?.trim();
  if (override) {
    return override.replace(/\/+$/, '');
  }
  if (process.env.NODE_ENV === 'development') {
    return DEFAULT_GEOCODE_PROXY_PATH;
  }
  return DEFAULT_GEOCODE_PROXY_PATH;
}
